import React from 'react';

import { PrePurchaseQuizModalProps } from '.';
import {
  PrePurchaseQuizModalInitialScreen,
  PrePurchaseQuizModalFirstStep,
  PrePurchaseQuizModalSecondStep,
  PrePurchaseQuizModalConfirmationStep,
  PrePurchaseQuizModalThirdStep,
  prePurchaseQuizModalOptionSelections,
  PrePurchaseQuizModalYouAreNotEligibleStep,
} from './PrePurchaseQuizModalSteps/PrePurchaseQuizModalSteps';

const questions = prePurchaseQuizModalOptionSelections().map(
  (questionComponent) => ({
    mainContent: questionComponent,
  }),
);

export function parsePrePurchaseQuizModalSteps(): PrePurchaseQuizModalProps {
  return {
    initialScreenContent: <PrePurchaseQuizModalInitialScreen />,
    steps: [
      {
        mainContent: <PrePurchaseQuizModalFirstStep />,
      },
      {
        mainContent: <PrePurchaseQuizModalSecondStep />,
      },
      {
        mainContent: <PrePurchaseQuizModalThirdStep />,
        backgroundColor: 'eggplant.wash',
      },
      ...questions,
    ],
    finalScreenContent: <PrePurchaseQuizModalConfirmationStep />,
    ineligibleScreenContent: <PrePurchaseQuizModalYouAreNotEligibleStep />,
  };
}
